import { Component, OnInit, ViewChild } from '@angular/core';
//import { RowHeightParams } from 'ag-grid-community';
import { DataService } from '@data/data.service';
import { getRowStyle, OrdersGridComponent } from '@grid/orders-grid/orders-grid.component';
import { ToolbarService } from '@toolbar/toolbar.service';
import { trimString } from '@util/utils';
import { BackendPaths } from '@common/backend-paths';
import { filterPartner, GridColumnStyles, setRawPhones } from '@common/common';

const partnerNrColumn = {
  field: 'id',
  headerName: 'ID',
  width: 100,
  maxWidth: 120
};

const partnerNameColumn = {
  field: 'name',
  headerName: 'Partner',
  minWidth: 200,
  flex: 1
};

export function getAddressParts(param: any) {
  const data = param.data;
  const parts: any[] = [];

  if (data.address) {
    parts.push(data.address);
  }

  if (data.zip || data.city) {
    let addr = '';
    if (data.zip) {
      addr = data.zip + ' ';
    }
    if (data.city) {
      addr += data.city;
    }
    parts.push(addr);
  }
  return parts;
}

/*
function getRowHeight(params: RowHeightParams):
  number | undefined | null {
  const parts = getAddressParts(params);
  return parts.length * 24;
}
*/

const addressColumn = {
  field: 'addr',
  headerName: 'Adresse',
  cellRenderer: (param: any) => {
    const parts = getAddressParts(param);
    return parts.join('<br>');
  },
  wrapText: true,
  minWidth: 200,
  flex: 1
};

const contactColumn = {
  field: 'contact',
  headerName: 'Kontakt',
  cellRenderer: (param: any) => {
    const item = param.data;
    if (item.phone || item.mobile) {
      const c: any[] = [];
      if (item.phone) {
        c.push('Tel: ' + item.phone);
      }
      if (item.mobile) {
        c.push('Mobil: ' + item.mobile);
      }
      return c.join("<br>");
    }
    return '';
  },
  minWidth: 200,
  flex: 1
};

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html'
})
export class PartnersComponent implements OnInit {

  gridOptions: any = {
    defaultColDef: {
      headerClass: function (params: any) {
        return 'def-col';
      },
      autoHeight: true,
      cellClass: GridColumnStyles.CELL_CLASS_STRING
    },
    columnDefs: [
      partnerNrColumn,
      partnerNameColumn,
      addressColumn,
      contactColumn
    ],
    enableCellTextSelection: true,
    alwaysShowHorizontalScroll: true,
    alwaysShowVerticalScroll: true,
    //getRowHeight: getRowHeight,
    getRowStyle
  };

  rows: any[] = [];

  private _grid!: OrdersGridComponent;

  @ViewChild('grid', {
    read: OrdersGridComponent
  }) set grid(grid: OrdersGridComponent) {
    this._grid = grid;
    grid && grid.setGridOptions(this.gridOptions);
  }

  onFilterChange($event: any) {
    if (this._grid) {
      const val = trimString($event).toLowerCase();
      if (val) {
        //const vals = splitSearchValue(val);
        const newRows = this.rows.filter((item: any) => {
          return filterPartner(item, [val]);
        });

        this._grid.setRowData(newRows);
      } else {
        this._grid.setRowData(this.rows);
      }
    }
  }

  constructor(
    private data: DataService,
    private toolbarService: ToolbarService
  ) {
  }

  ngOnInit(): void {
    this.toolbarService.setTitle('Partner');

    this.data.get(BackendPaths.PARTNERS).subscribe((result: any) => {
      const res = result?.result;

      if (Array.isArray(res?.rows)) {
        this.rows = res.rows;
        this.rows.forEach((item: any) => {
          if (!item.name) {
            item.name = (item.fname || '') + ' ' + (item.lname || '');
          }
          setRawPhones(item);
        });

        const grid = this._grid;
        grid && grid.setRowData(this.rows);
      } else {

      }
    });
  }
}
